module.exports = __webpack_public_path__ + "img/baie_coulissante.e79413a.svg";